import jsPDF from 'jspdf';
import moment from 'moment';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportRemitoPreimpresoPDF (remito, renglones, empresa, save) {
      let pdfName = 'remito_'; 
      pdfName = pdfName.concat(remito.numero.toString().trim()); 
      /* Parametros: portrait, milimetros, A4 */
      var doc = new jsPDF('p', 'mm', 'a4');

      doc.setProperties({
        title: 'Remito',
        subject: 'Remito',		
        author: 'Cervertti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      let fontName = 'Montserrat-Regular';
      let fontSemiBoldName = 'Montserrat-SemiBold';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      remito.cuit = this.$options.filters.cuit(remito.cuit);

      let ajusteY = 0;
      
      /* Formato para alinear numeros a la derecha */
      let alignRight = {
        'align': 'right'
      }
      
      drawCabecera(doc, remito, fontName, fontSemiBoldName, fontBoldName, ajusteY);
        
        /* Renglones */
      if (renglones) {
        let positionRenglonesY = 96;
        let interlineadoRenglones = 4;

        doc.setFont(fontName, 'normal');
        doc.setFontSize(9);
        doc.setTextColor(60, 60, 60);

        renglones.forEach(renglon => {
          if (renglon.renglonNumero <= 30) {
            if (renglon.cantidad.trim() != '') {
              let length = renglon.cantidad.trim().length;
              let spaces = (10 - length) / 2;
              
              doc.text(renglon.cantidad.trim(), 14 + spaces, 
                ((renglon.renglonNumero - 1) * interlineadoRenglones) + positionRenglonesY + ajusteY);  
            }
  
            doc.text(renglon.descripcion.trim(), 35, 
              ((renglon.renglonNumero - 1) * interlineadoRenglones) + positionRenglonesY + ajusteY);
          }
        });
      }

      doc.setFont(fontBoldName, 'bold');
      doc.setTextColor(60, 60, 60);
      if ((/true/i).test(remito.entregaPersonal)) {
        doc.setFontSize(10);
        doc.text(remito.formaEntrega.trim(), 12, 236 + ajusteY);
      } else {
        doc.setFontSize(8);
        doc.setFont(fontSemiBoldName, 'normal');
        doc.text('Valor Declarado: ', 12, 234 + ajusteY);
        doc.setFont(fontBoldName, 'bold');
        doc.text(this.$options.filters.moneda(remito.valorDeclarado), 39, 234 + ajusteY);
        doc.setFont(fontSemiBoldName, 'normal');
        doc.text('Transporte: ', 12, 238 + ajusteY);
        doc.setFont(fontBoldName, 'bold');
        doc.text(remito.formaEntrega.trim(), 31,  238 + ajusteY);
        doc.text(`Pago de Flete en Cuenta Corriente - ${empresa.nombreComercial}`, 12, 242 + ajusteY);
      }

      doc.setFont(fontSemiBoldName, 'normal');
      doc.setFontSize(12);
      // let cadenaTipoEnvio = `CANTIDAD ${remito.tipoEnvio.trim()}`;
      // let length = cadenaTipoEnvio.length;
      // let spaces = (50 - length) / 2;
      // doc.text(cadenaTipoEnvio.trim(), 122 + spaces, 234 + ajusteY);
      
      // doc.setFontSize(14);
      // let cadenaCantidad = `${remito.cantidad.toString()}`;
      // length = cadenaCantidad.length;
      // spaces = (50 - length) / 2;
      // doc.text(cadenaCantidad.trim(), 136 + spaces, 242 + ajusteY);

      let interlineadoCantidades = 5;
      let tienePaquetes = remito.cantidadPaquetes != 0 ? true : false;
      let tieneBultos = remito.cantidadBultos != 0 ? true : false;
      let tienePallets = remito.cantidadPallets != 0 ? true : false;
      
      let positionY;
      let positionBultos = 234;

      if (tienePaquetes & tieneBultos & tienePallets) {
        positionY = positionBultos;
      } else if ( (tienePaquetes & tieneBultos & !tienePallets) || (tienePaquetes & !tieneBultos & tienePallets) || (!tienePaquetes & tieneBultos & tienePallets)) {
        positionY = positionBultos + 2;
        interlineadoCantidades = 6;
      } else {
        positionY = positionBultos + 5;
      }

      if (remito.cantidadPaquetes != 0) {
        doc.text( `CANTIDAD PAQUETES: ${remito.cantidadPaquetes}` , 128, positionY);
        positionY += interlineadoCantidades;
      }
      if (remito.cantidadBultos != 0) {
        doc.text( `CANTIDAD BULTOS: ${remito.cantidadBultos}` , 128, positionY);
        positionY += interlineadoCantidades;
      }
      if (remito.cantidadPallets != 0) {
        doc.text( `CANTIDAD PALLETS: ${remito.cantidadPallets}` , 128, positionY);
      }

      if (save) {
        doc.save(pdfName + '.pdf');
      } else {
        window.open(doc.output("bloburl", { filename: 'remito.pdf' } ));
      }

      return;
    },
  }
}

function drawCabecera(doc, remito, fontName, fontSemiBoldName, fontBoldName, ajusteY) {
  doc.setFont(fontName, 'normal');
  doc.setFontSize(8);
  doc.setTextColor(60, 60, 60);
  doc.text(moment(remito.fechaComprobante).format('DD/MM/YYYY'), 182, 23 + ajusteY);

  /* Datos del destino */

  doc.setFont(fontSemiBoldName, 'normal');
  doc.text('Destinatario:', 10, 59 + ajusteY);
  doc.setFont(fontName, 'normal');
  doc.text(remito.remitoDestino.trim(), 32, 59 + ajusteY);

  if (remito.documentoNumero.trim() != '') {
    if (remito.documentoTipo.trim() == '') {
      doc.setFont(fontSemiBoldName, 'normal');
      doc.text('Nro.Documento:', 130, 59 + ajusteY);
      doc.setFont(fontName, 'normal');
      doc.text(remito.documentoNumero.trim(), 142, 59 + ajusteY);  
    } else {
      doc.setFont(fontSemiBoldName, 'normal');
      doc.text(`${remito.documentoTipo.trim()}:`, 130, 59 + ajusteY);
      doc.setFont(fontName, 'normal');
      doc.text(remito.documentoNumero.trim(), 138, 59 + ajusteY);  
    }
  }

  doc.setFont(fontSemiBoldName, 'normal');
  doc.text('Domicilio:', 10, 64 + ajusteY);
  doc.setFont(fontName, 'normal');
  doc.text(remito.direccion.trim(), 28, 64 + ajusteY);

  doc.setFont(fontSemiBoldName, 'normal');
  doc.text('Localidad:', 10, 69 + ajusteY);
  doc.setFont(fontName, 'normal');
  doc.text(`${remito.localidad.trim()} (${remito.provincia.trim()})`, 28, 69 + ajusteY);

  doc.setFont(fontSemiBoldName, 'normal');
  doc.text('Cod. Postal:', 10, 74 + ajusteY);
  doc.setFont(fontName, 'normal');
  doc.text(remito.codigoPostal.trim(), 30, 74 + ajusteY);

  // if (remito.contacto.trim() != '' & remito.contacto.trim() != remito.remitoDestino.trim()) {
  //   doc.setFont(fontBoldName, 'bold');
  //   doc.text('Contacto:', 10, 79 + ajusteY);
  //   doc.setFont(fontName, 'normal');
  //   doc.text(remito.codigoPostal.trim(), 35, 79 + ajusteY);

  //   doc.setFont(fontBoldName, 'bold');
  //   doc.text('Teléfono:', 10, 84 + ajusteY);
  //   doc.setFont(fontName, 'normal');
  //   doc.text(remito.contactoTelefono.trim(), 26, 84 + ajusteY);
  // } else {
    doc.setFont(fontSemiBoldName, 'normal');
    doc.text('Teléfono:', 10, 79 + ajusteY);
    doc.setFont(fontName, 'normal');
    doc.text(remito.contactoTelefono.trim(), 26, 79 + ajusteY);
  // }

  if (remito.presupuestoInternoId != 0) {
    doc.setFont(fontSemiBoldName, 'normal');
    doc.text('Ref.:', 130, 69 + ajusteY);
    doc.setFont(fontName, 'normal');
    if (remito.ordenTrabajoId != 0) {
      doc.text(`${remito.presupuestoNumero.trim()}/${remito.ordenTrabajoId.toString().trim()}`, 138, 69 + ajusteY);
    } else {
      doc.text(remito.presupuestoNumero.trim(), 138, 69 + ajusteY);
    }

    doc.setFont(fontBoldName, 'bold');
    doc.text(remito.cliente.trim(), 130, 74 + ajusteY);

    doc.setFont(fontBoldName, 'bold');
    doc.text(remito.accion.trim(), 130, 79 + ajusteY);
  }
}
